import React, { useContext } from 'react'
import DatosPersonalesCtrl from './DatosPersonales/DatosPersonalesCtrl'
import DatosDeRepresentacionesCtrl from './DatosDeRepresentaciones/DatosDeRepresentacionesCtrl'
import IE11Detector from './IE11/IE11Detector'
import { AppContext } from '../../App'
//import { useAuth } from "react-oidc-context"
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import IconButton from '@material-ui/core/IconButton';



function CuerpoApp(){
  
    const {state, dispatch} = useContext(AppContext);

    /*const auth = useAuth();
    if (!auth.isAuthenticated) {    
    
        auth.signinRedirect()
        
      }
*/

    return <>
      
        <div className="col-sm-10 col-lg-offset-1 sin-float" id="bloque">            

            <div className="modal-header-img">
                <div style={{ display: 'flex', flexWrap: 'nowrap',}}>                
                    <h1 style={{ display: 'inline-block', textAlign : 'center', marginTop : '20px',}}>Censo de representación voluntaria de Hacienda Navarra y TEAFN</h1>                                              
                </div>  
            </div>


            <div className="modal-body">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <p>
                            <strong>Gestión de la representación, a través de las siguientes actuaciones</strong>
                            <br/>
                        </p>
                    </div>
                    <div className="con-margen-izq">
                        <br/>
                        <IE11Detector></IE11Detector>
                        <DatosPersonalesCtrl></DatosPersonalesCtrl>
                        <br/>
                        {state.nifNombreUsuario != '' &&    
                        <DatosDeRepresentacionesCtrl></DatosDeRepresentacionesCtrl>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default  CuerpoApp